module.exports = __webpack_public_path__ + "img/446f8f7.jpg";